
import {getJackpotView} from '../api/getJackpotView';
import {setGetJackpotViewAction} from '../action';

const setGetJackpotView = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getJackpotView(params);

            if (data.status === 'success') {
                dispatch(setGetJackpotViewAction({
                    id: data.data.id,
                    name: data.data.label,
                    groups: data.data.groups,
                    jackpot: data.data.jackpot,
                    primary_storage: data.data.primary_storage,
                    secondary_storage: data.data.secondary_storage,
                    min_win: data.data.min_win,
                    max_win: data.data.max_win,
                    min_bet: data.data.min_bet,
                    max_bet: data.data.max_bet,
                    give: data.data.give,
                    visible: data.data.visible,
                    currency: data.data.currency
                }));           
            }          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetJackpotView
}